import { FormInstance } from 'antd';
import { useHasValidDisputeFiles } from '@pay-bill/hooks';

export const useHasValidMissingLineDisputeFields = (
  form: FormInstance,
  formValues: Record<string, unknown>
) => {
  const hasValidFiles = useHasValidDisputeFiles(form);

  const allFieldsFilledIn = !!(
    formValues.newHours &&
    formValues.newDate &&
    formValues.newPayCode &&
    formValues.comment
  );

  return hasValidFiles && allFieldsFilledIn;
};
